export const dashboardNavigation = [
      {
          text: 'Overview',
          icon: 'chart',
          path: '/dashboard/overview'
      },{
            text: 'integrations',
            icon: 'preferences',
            path: '/dashboard/integrations'
      }
];
  